import React, { lazy, Suspense } from 'react'

import MDXRenderer, {
  shortcodes,
} from '@babelcoder/gatsby-theme-base/src/components/mdx/Renderer'
import { Codesandbox } from '@babelcoder/gatsby-theme-base/src/components/Codesandbox'
import VideoPlayer from '@babelcoder/gatsby-theme-courses/src/components/courses/VideoPlayer'
import UnitsTable from './UnitsTable'
import Instructor from './Instructor'
import Organizations from './Organizations'

const coursesShortCodes = {
  ...shortcodes,
  UnitsTable,
  Instructor,
  Organizations,
  Codesandbox,
  VideoPlayer,
}

function Renderer({ children }) {
  return (
    <>
      <MDXRenderer shortcodes={coursesShortCodes}>{children}</MDXRenderer>
    </>
  )
}

export default Renderer
